<div class="Home">
  <header class="sticky-top">
    <div class="header_title text-center py-2">おしゃべりリマインダー</div>
  </header>
  <b-offcanvas v-model="state_data.sidemenu" title="メニュー" style="width:75%;"
        header-class="bg-secondary text-light" body-class="px-0 py-0">
    <b-list-group class="mx-0 px-0">
      <b-list-group-item button @click="edit()">設定編集</b-list-group-item>
      <b-list-group-item button @click="retire_open()">退会</b-list-group-item>
      <b-list-group-item button @click="signout_open()">サインアウト</b-list-group-item>
    </b-list-group>
  </b-offcanvas>
  
  <!-- ローディング -->
  <loading v-model:active="loader.is_loading" :is-full-page="loader.is_full_page"></loading>
  <!-- メッセージ -->
  <b-alert v-model="message.is_alert" dismissible :variant="message.variant">{{ message.message }}</b-alert>

  <b-container class="px-0">
    <div class="text-center mt-4">
      <img alt="おしゃべりリマインダー" src="../../assets/chatty-reminders-image-1000x545.png" class="img-fluid" />
    </div>
    <div class="text-center mt-4 mx-4">
      <div class="markdown-body" v-html="bind_data.markdowntext"></div>
    </div>
    
    <footer class="sticky-bottom">
      <b-row>
        <b-col class="d-grid gap-2" lg="4" md="12">
          <b-button variant="outline-primary" class="mt-2 mx-4 btn" size="sm" @click="qa()">よくあるご質問</b-button>
        </b-col>
        <b-col class="d-grid gap-2" lg="4" md="12">
          <b-button block variant="outline-primary" class="mt-2 mx-4 btn" size="sm" @click="privacy_policy()">プライバシーポリシー</b-button>
        </b-col>
        <b-col class="d-grid gap-2" lg="4" md="12">
          <b-button block variant="outline-primary" class="mt-2 mx-4 btn" size="sm" @click="terms_of_service()">利用規約</b-button>
        </b-col>
      </b-row>
      <br>
    </footer>
  </b-container>
  
</div>